import { useState } from 'react';
import pharmacy from 'services/pharmacy';
import { useHistory } from 'react-router-dom';
import dateFunctions from 'helpers/dateFunction';

const useIsOffboardingPharmacy = () => {
  const history = useHistory();
  const [offboardingData, setOffboardingData] = useState({
    pharmacyName: '',
    offboardingDate: null,
    showFulfillmentMessage: false,
    showBasketMessage: false,
  });
  const [loading, setLoading] = useState(false);
  const isOffboarding = async (payload) => {
    setLoading(true);
    if (payload?.toUpperCase() === 'FGF90' || !payload) {
      setLoading(false);
      return;
    }

    try {
      const pharmacyDetails = await pharmacy.get(`/pharmacies/${payload}`);
      const {
        data: { name, close_date },
      } = pharmacyDetails;

      const dates = [close_date && new Date(close_date)].filter((i) => i);

      const offboardingDate = dates.length ? new Date(Math.min(...dates)) : null;

      setOffboardingData((state) => ({
        ...state,
        pharmacyName: name,
        offboardingDate: offboardingDate && dateFunctions.formatDateWithNthNumber(offboardingDate, 'short'),
        showFulfillmentMessage: offboardingDate ? new Date() > offboardingDate : false,
        showBasketMessage: offboardingDate ? new Date() < offboardingDate : false,
      }));

      setLoading(false);
    } catch (err) {
      const {
        response: { status },
      } = err;
      if (status === 404) {
        setOffboardingData((state) => ({
          ...state,
          showFulfillmentMessage: true,
        }));
        setLoading(false);
      } else {
        setLoading(false);
        history.push('/pharmacy/error');
      }
    }
  };
  return [offboardingData, loading, isOffboarding];
};

export default useIsOffboardingPharmacy;
